import * as React from "react";
import { Modal, Button, Tooltip } from "antd";
import ManageGatepassForm from "../Form/ManageGatePassForm";
import {
  EditOutlined,

  // CloseOutlined,
  // CheckOutlined,
} from "@ant-design/icons";

export const ManageGatepassModalContext = React.createContext<{
  setIsModalVisible: (active: boolean) => void;
}>({
  setIsModalVisible: () => true,
});

const GatepassManageModal: React.FC<{ id: number }> = ({ id }) => {
  const [isModalVisible, setIsModalVisible] = React.useState(false);

  const showModal = () => setIsModalVisible(true);

  const handleOk = () => setIsModalVisible(false);

  const handleCancel = () => setIsModalVisible(false);

  return (
    <ManageGatepassModalContext.Provider value={{ setIsModalVisible }}>
      <Tooltip title="Edit/Update">
        <Button
          onClick={showModal}
          type="primary"
          shape="circle"
          icon={<EditOutlined />}
        />
      </Tooltip>
      <Modal
        width={1000}
        title="Manage Gatepass"
        visible={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={null}
      >
        <ManageGatepassForm id={id} />
      </Modal>
    </ManageGatepassModalContext.Provider>
  );
};

export default GatepassManageModal;
